export const PANCHANG_COPY = {
  en: {
    eyebrow: "Aaj Ka Panchang",
    headline: "Today's Panchang",
  },
  hi: {
    eyebrow: "आज का पंचांग",
    headline: "आज का पंचांग",
  },
} as const;
